import { render, staticRenderFns } from "./ConnectionHeaderBlock.vue?vue&type=template&id=94e0f1f6"
import script from "./connectionHeaderBlock.ts?vue&type=script&lang=js&external"
export * from "./connectionHeaderBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports